// extracted by mini-css-extract-plugin
export default {"root":"styles_root__z8RD+","infoCardsWrap":"styles_infoCardsWrap__WDaHi","woList":"styles_woList__3-g2m"};